import styled from 'styled-components';

export default styled.h4`
    
`